/**
 * Service for fetching and caching field metadata from the backend
 */

import { FieldMetadataMap } from '../../../workers/src/_shared/fieldMetadata.types'
import { supabase } from '../supabase'

let cachedFieldMetadata: FieldMetadataMap | null = null;

export async function getFieldMetadata(): Promise<FieldMetadataMap> {
    if (cachedFieldMetadata) {
        return cachedFieldMetadata;
    }

    const session = await supabase.auth.getSession()
    if (!session.data.session) {
        throw new Error('No session found');
    }

    const workerUrl = import.meta.env.VITE_WORKERS_URL;
    const response = await fetch(`${workerUrl}/rainfactory/brand-genius/get_field_metadata`, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${session.data.session.access_token}`
        }
    });

    if (!response.ok) {
        throw new Error('Failed to fetch field metadata');
    }

    const data = await response.json();
    cachedFieldMetadata = data as FieldMetadataMap;
    return cachedFieldMetadata;
}

export function getFieldMetadataByName(fieldName: string, metadata: FieldMetadataMap) {
    const fieldMetadata = metadata[fieldName];
    if (!fieldMetadata) {
        throw new Error(`No metadata found for field: ${fieldName}`);
    }
    return fieldMetadata;
}

// Clear cache if needed (e.g., after updates)
export function clearFieldMetadataCache() {
    cachedFieldMetadata = null;
} 